(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-query-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.ec-search-query-form')) return;

  // Facets update the URL without replacing this form. Use their latest state.
  const currentParams = new URL(window.location.href).searchParams;
  for (const input of form.querySelectorAll('input[type="hidden"]')) {
    if (input.name.startsWith('filter.') || ((input.name === 'sort_by' || input.name === 'type') && currentParams.has(input.name))) {
      input.remove();
    }
  }

  for (const [name, value] of currentParams) {
    if (name.startsWith('filter.') || name === 'sort_by' || name === 'type') {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.append(input);
    }
  }
});
  } catch(e) { console.error(e); }
})();

})();
